import { render } from "./BlockImage.vue?vue&type=template&id=7eb41d01"
import script from "./BlockImage.vue?vue&type=script&lang=js"
export * from "./BlockImage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__